import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

import icon from '../media/icon.png'

import { AuthSessionX } from "../services/user-accounts";

export default function AuthSessionXModule() {

  setTimeout(() => {
    AuthSessionX();
  }, 1000);

  return (
    <>
    <div className="container">
      <div className="row">
        <div className="col d-none d-md-block"></div>
        <div className="col">
          <div className="text-center">
            <div className="py-3"></div>
            <div className="py-3"></div>
            <img  src={icon}  width="60" height="60" alt="..." className=""></img>
            <div className="py-3"></div>
            <p className="small">Logout User</p>
            <p className="small">Please Wait...</p>
          </div>

        </div>
        <div className="col d-none d-md-block"></div>
      </div>
      
    </div>

    </>
  )
}